import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { MetaData, UrlType } from '@nxte-nl/metadata-helmet';

import { routerHooks } from '../../hooks/routerHooks/routerHooks';
import { MetadataContainer } from '../MetadataContainer/MetadataContainer';

export const hooks = {
  useRedirectWithParams() {
    const pushHandler = routerHooks.usePushQueryHandler();
    const pathname = routerHooks.usePathName();

    const [link, setLink] = React.useState<string>();

    const redirectWithParams = React.useCallback(() => {
      pushHandler({
        setParams: { '404': '' },
        deleteParams: [],
      });

      return {
        link: `${pathname}/?404`,
      };
    }, [pathname, pushHandler]);

    React.useEffect(() => {
      const { link } = redirectWithParams();

      setLink(link);
    }, [redirectWithParams]);

    return link;
  },
};

const messages = defineMessages({
  title: {
    id: 'src.components.NotFoundMetaDataContainer.title',
    defaultMessage: '[[ 404, this page was not found ]]',
  },
  description: {
    id: 'src.components.NotFoundMetaDataContainer.description',
    defaultMessage: '404 description',
  },
});

export const NotFoundMetaDataContainer = React.memo(() => {
  const intl = useIntl();

  const title = intl.formatMessage(messages.title);
  const description = intl.formatMessage(messages.description);

  const link = hooks.useRedirectWithParams();

  const metaData: MetaData = React.useMemo(() => ({
    title,
    description,
    noindex: true,
    nofollow: true,
    keywords: [],
    hreflangTags: [{
      langCode: CONFIG.metaHrefLang,
      path: {
        type: UrlType.RELATIVE,
        href: link || '',
      },
    }],
  }), [description, link, title]);

  return (
    <MetadataContainer
      metaData={metaData}
    />
  );
});

NotFoundMetaDataContainer.displayName = 'NotFoundMetaDataContainer';
